import React, { useState, useEffect } from 'react';
import {PageTitle} from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder';

import { IReport, fetchReports } from '../api';
import { useWebsite } from '../hooks/useWebsite';
import ReportCard from './components/cards/ReportCard';
import CreateReportForm from './forms/CreateReportForm';

const Breadcrumbs = BreadcrumbsBuilder([
  { title: 'Home',  path: '/' },
  { title: 'Analytics',  path: '/analytics/overview' },
]);

const ReportsPage = () => {
  const [reports, setReports] = useState<Array<IReport>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { websiteId } = useWebsite();

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data: Array<IReport> = await fetchReports(websiteId);
      setReports(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchData() }, [websiteId]);

  if (isLoading) {
    return <>Loading ...</>
  }

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>My reports</PageTitle>

      <CreateReportForm onSuccess={fetchData} />

      {reports.map((r: IReport, i: number) => (
        <ReportCard key={`report-${i}`} report={r} />
      ))}
    </>
  );
}

export default ReportsPage;
